





























import Vue from "vue";
import RequestHandler from "@/assets/ts/requestHandler";
import { AccountDropdownItems } from "@/types";

const RH = new RequestHandler();

export default Vue.extend({
  data: function() {
    return {
      isSSO: localStorage.getItem("ssoData") !== null
    };
  },
  methods: {
    userMenuItems: function(): AccountDropdownItems[] {
      return [
        {
          isAccountItem: true,
          title: this.$store.getters.userInfo.username,
          icon: "mdi-account",
          permission: [],
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          action: () => {}
        },
        {
          icon: "mdi-magnify",
          title: "Search",
          permission: ["Employer", "Employee"],
          action: () => {
            this.$router.push({ name: "Search" });
          }
        },
        {
          icon: "mdi-account-edit",
          title: "Edit Account",
          permission: ["Employer"],
          action: () => {
            this.$router.push({ name: "EditUserAccount" });
          }
        },
        {
          icon: "mdi-account-edit",
          title: "Edit Account",
          permission: ["EmployerEdit"],
          action: () => {
            this.$router.push({ name: "EditMode" });
          }
        },
        {
          icon: "mdi-account-edit",
          title: "Edit Account",
          permission: ["Employee"],
          action: () => {
            this.$root.$emit("open-employee-edit-dialog");
          }
        },
        {
          icon: "mdi-file-document-edit",
          title: "Manage Employees",
          permission: ["Employer"],
          action: () => {
            this.$router.push({ name: "EmployeeManagement" });
          }
        },
        {
          icon: "mdi-file-document-multiple-outline",
          title: "Reports",
          permission: ["Employer"],
          action: () => {
            this.$router.push({ name: "Reports" });
          }
        },
        {
          icon: "mdi-account-edit",
          title: "Account Management",
          permission: ["Administrator"],
          action: () => {
            this.$router.push({ name: "Administration" });
          }
        },
        {
          icon: "mdi-table-alert",
          title: "Stolen Hits Grid",
          permission: ["Administrator"],
          action: () => {
            this.$router.push({ name: "NCICHits" });
          }
        },
        {
          icon: "mdi-logout",
          title: "Log Out",
          permission: ["Administrator", "Employer", "EmployerEdit", "Employee"],
          action: async () => {
            if (this.isSSO) {
              this.$vtrs.logout();
            } else {
              await RH.logout(this.$store.getters.userInfo.token);
              this.$router.push({ name: "Login" });
            }
          }
        }
      ];
    }
  }
});
